// extracted by mini-css-extract-plugin
export default {"erir":"styles_erir__YV8FC","erir_info":"styles_erir_info__0fkN-","status":"styles_status__SNbQJ"};